// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Technologies3DPrinting_heroBlock__8MZ6M { display: flex; flex-direction: column; gap: var(--space-6); }

.Technologies3DPrinting_text__djEqI {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.Technologies3DPrinting_text__djEqI h2 {
  margin: 0;
}

.Technologies3DPrinting_text__djEqI p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--text-secondary);
  max-width: 52ch;
}

.Technologies3DPrinting_closing__JfNp2 {
  align-items: center;
  text-align: center;
}

.Technologies3DPrinting_closingText__dlPKw {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--text-secondary);
  max-width: 60ch;
}

.Technologies3DPrinting_closingRow__gjgG0 {
  justify-content: center;
}

@media (max-width: 480px) {
  .Technologies3DPrinting_closingRow__gjgG0 {
    flex-direction: column;
    width: 100%;
  }

  .Technologies3DPrinting_closingRow__gjgG0 > * {
    width: 100%;
  }
}

/* Phones: fill the photo frame instead of letterboxing a portrait shot in black,
   and keep it short enough that the copy stays on screen. */
@media (max-width: 560px) {
  .Technologies3DPrinting_heroBlock__8MZ6M {
    gap: var(--space-5);
  }

  .Technologies3DPrinting_photo__TBFN1 {
    aspect-ratio: 4 / 3;
  }

  .Technologies3DPrinting_photo__TBFN1 > img {
    object-fit: cover;
  }

  .Technologies3DPrinting_text__djEqI p,
  .Technologies3DPrinting_closingText__dlPKw {
    font-size: .9375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Technologies3DPrinting.module.css"],"names":[],"mappings":"AAAA,2CAAa,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;4DAC4D;AAC5D;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".heroBlock { display: flex; flex-direction: column; gap: var(--space-6); }\n\n.text {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  min-width: 0;\n}\n\n.text h2 {\n  margin: 0;\n}\n\n.text p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  max-width: 52ch;\n}\n\n.closing {\n  align-items: center;\n  text-align: center;\n}\n\n.closingText {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  max-width: 60ch;\n}\n\n.closingRow {\n  justify-content: center;\n}\n\n@media (max-width: 480px) {\n  .closingRow {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .closingRow > * {\n    width: 100%;\n  }\n}\n\n/* Phones: fill the photo frame instead of letterboxing a portrait shot in black,\n   and keep it short enough that the copy stays on screen. */\n@media (max-width: 560px) {\n  .heroBlock {\n    gap: var(--space-5);\n  }\n\n  .photo {\n    aspect-ratio: 4 / 3;\n  }\n\n  .photo > img {\n    object-fit: cover;\n  }\n\n  .text p,\n  .closingText {\n    font-size: .9375rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroBlock": `Technologies3DPrinting_heroBlock__8MZ6M`,
	"text": `Technologies3DPrinting_text__djEqI`,
	"closing": `Technologies3DPrinting_closing__JfNp2`,
	"closingText": `Technologies3DPrinting_closingText__dlPKw`,
	"closingRow": `Technologies3DPrinting_closingRow__gjgG0`,
	"photo": `Technologies3DPrinting_photo__TBFN1`
};
export default ___CSS_LOADER_EXPORT___;
